exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frame[data-v-7b53f186]{position:relative;padding-bottom:var(--frame-pad)}.frame>*[data-v-7b53f186]{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden}.frame>img[data-v-7b53f186],.frame>video[data-v-7b53f186]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
